import { experimentalQuery } from '../../entry-points/experimentalQuery.ts';
import { MediaType } from '../MediaType.ts';
import type { FetchPolicy } from '../useExperimentalQuery.ts';

interface ExperimentalPromotedSpace {
	id?: string | null;
	text?: string | null;
	__typename?: 'ExperimentalPromotedSpace';
}

export interface ExperimentalPromotedSpacesData {
	experimentalPromotedSpaces: {
		nodes?: (ExperimentalPromotedSpace | null)[] | null;
		matchedPromotedSpaces?: (ExperimentalPromotedSpace | null)[] | null;
		__typename?: 'ExperimentalPromotedSpaces';
	} | null;
}

interface PromotedSpacesVariables {
	promotedSpacesLimit?: number | null;
	otherSpacesLimit?: number | null;
	promotedSpaceKey?: string | null;
}

interface PromotedSpacesAPIResponse {
	matchedPromotedSpaces?: {
		spaces?: ExperimentalPromotedSpace[];
	};
	promotedSpaces?: {
		spaces?: ExperimentalPromotedSpace[];
	};
	otherSpaces?: {
		spaces?: ExperimentalPromotedSpace[];
	};
}

export const experimentalPromotedSpacesQuery = async ({
	variables,
	fetchPolicy,
}: {
	variables?: PromotedSpacesVariables;
	fetchPolicy?: FetchPolicy;
}): Promise<{ data: ExperimentalPromotedSpacesData }> => {
	const promotedSpacesLimit = (variables && variables.promotedSpacesLimit) || 10;
	const otherSpacesLimit = (variables && variables.otherSpacesLimit) || 10;
	const promotedSpaceKey = (variables && variables.promotedSpaceKey) || '';

	const result = await experimentalQuery<
		ExperimentalPromotedSpacesData,
		PromotedSpacesVariables,
		PromotedSpacesAPIResponse
	>({
		url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
		method: 'GET',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		variables: variables || {},
		fetchPolicy,
		parseResult: (json): ExperimentalPromotedSpacesData => {
			const matchedPromotedSpaces =
				(json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces) || [];
			const nodes = ((json.promotedSpaces && json.promotedSpaces.spaces) || []).concat(
				(json.otherSpaces && json.otherSpaces.spaces) || [],
			);
			return {
				experimentalPromotedSpaces: {
					nodes,
					matchedPromotedSpaces,
					__typename: 'ExperimentalPromotedSpaces',
				},
			};
		},
	});

	return { data: result.data };
};
